import React from 'react';
import { motion } from 'framer-motion';
import { BookMarked } from 'lucide-react';
const tomos = [{
  title: 'Tomo 1 — Evaluación Clínica Inteligente',
  desc: 'Para dejar de improvisar el inicio del caso y empezar a evaluar con estructura profesional desde la primera consulta.'
}, {
  title: 'Tomo 2 — Planificación Terapéutica Inteligente',
  desc: 'Para construir tratamientos más claros, estratégicos y coherentes con el proceso real del paciente.'
}, {
  title: 'Tomo 3 — Biblioteca de Intervención Clínica',
  desc: 'Para tener siempre a mano herramientas prácticas que te ahorren tiempo y te den más seguridad al intervenir.'
}, {
  title: 'Tomo 4 — Seguimiento y Evolución Clínica',
  desc: 'Para convertir cada sesión en información útil, medir avances y mostrar resultados con más claridad.'
}, {
  title: 'Tomo 5 — Informes y Documentación Profesional',
  desc: 'Para comunicar tu trabajo con documentos más sólidos, claros y profesionales sin perder horas redactando.'
}, {
  title: 'Tomo 6 — Gestión Profesional de Consultorio',
  desc: 'Para ordenar el funcionamiento del consultorio y trabajar con más control, menos caos y mejor imagen profesional.'
}];
export function PackContent() {
  return <section className="py-8 relative bg-transparent" data-id="element-109">
      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-112">
            El <span className="text-gradient" data-id="element-113">MegaPack</span> incluye estos{' '}
            <span className="text-gradient" data-id="element-114">6 Tomos</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-115">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#0a0a0a] p-6 rounded-2xl flex gap-4 border border-orange-500/40 hover:border-orange-500/70 transition-colors" data-id="element-116">
              <div className="mt-1" data-id="element-117">
                <BookMarked className="w-6 h-6 text-orange-500" data-id="element-118" />
              </div>
              <div data-id="element-119">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-120">
                  {tomo.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-121">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}